// extracted by mini-css-extract-plugin
module.exports = {"overlay":"equipment-loader_overlay__UMtPT","overlay__spinner":"equipment-loader_overlay__spinner__LEO_V"};